<script lang="ts">
    import Truncate from '@amp/web-app-components/src/components/Truncate/Truncate.svelte';
    import { getI18n } from '~/stores/i18n';

    const i18n = getI18n();
    export let text: string;
</script>

<div class="paragraph-item" data-testid="paragraph-item">
    <Truncate {text} lines={8} modalType="contentModal" translateFn={$i18n.t} />
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/mixins/margin-gutter' as *;

    .paragraph-item {
        display: flex;
        align-items: flex-end;

        @include margin-gutter(0, 13px);

        @media (--medium) {
            max-width: 75%;
        }
    }
</style>
